import React from 'react';
import { motion } from 'framer-motion';
export function ScatteredTools() {
  const tools = [{
    name: 'Meta Ads',
    holds: 'Ad spend',
    color: '#1877F2'
  }, {
    name: 'Google Ads',
    holds: 'Clicks & cost',
    color: '#EA4335'
  }, {
    name: 'CRM',
    holds: 'Leads & deals',
    color: '#00A4EF'
  }, {
    name: 'Stripe',
    holds: 'Payments',
    color: '#635BFF'
  }, {
    name: 'QuickBooks',
    holds: 'Accounting',
    color: '#2CA01C'
  }, {
    name: 'Analytics',
    holds: 'Traffic',
    color: '#FF6C37'
  }, {
    name: 'Calendar',
    holds: 'Appointments',
    color: '#EAB308'
  }, {
    name: 'Spreadsheets',
    holds: 'Everything else',
    color: '#00D084'
  }];
  return <section className="py-32" data-id="element-276">
      <div className="max-w-5xl mx-auto px-6" data-id="element-277">
        <div className="text-center mb-16" data-id="element-278">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold mb-4" data-id="element-279">
            Your answers are everywhere.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-base md:text-lg text-textSecondary max-w-xl mx-auto" data-id="element-280">
            Every tool holds a piece of the truth. None of them talk to each
            other.
          </motion.p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4" data-id="element-281">
          {tools.map((tool, i) => <motion.div key={tool.name} initial={{
          opacity: 0,
          x: -16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} className={`bg-card border border-white/5 rounded-xl p-4 ${i % 2 === 0 ? 'md:-rotate-2' : 'md:rotate-2'}`} data-id="element-282">
              <div className="text-sm font-bold mb-1" style={{
            color: tool.color
          }} data-id="element-283">
                {tool.name}
              </div>
              <div className="text-[11px] text-textSecondary mb-3" data-id="element-284">
                {tool.holds}
              </div>
              <div className="space-y-1.5" data-id="element-285">
                <div className="h-2 bg-white/10 rounded w-full" data-id="element-286" />
                <div className="h-2 bg-white/10 rounded w-2/3" data-id="element-287" />
                <div className="h-8 mt-2 rounded" style={{
              backgroundColor: `${tool.color}22`
            }} data-id="element-288" />
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}